import clsx from 'clsx';
import React from 'react';
import { useAuthStore } from '@/stores/authStore';
import { isLivenessVerified } from '@/utils/isVerified';

type CreatePoolButtonProps = {
  onClick: () => void;
  className?: string;
};

export const CreatePoolButton: React.FC<CreatePoolButtonProps> = ({ onClick, className = '' }) => {
  const user = useAuthStore((state) => state.user);
  const isDisabled = !isLivenessVerified(user);

  return (
    <div
      className={clsx(
        'flex items-center group w-full overflow-hidden min-h-[120px] lg:min-h-[138px] transition-all duration-300',
        'px-6 py-6 bg-[#EBF4FF] rounded-3xl',
        !isDisabled && 'hover:px-10 hover:bg-[#BFCDE1] hover:rounded-[54px]',
        className,
        isDisabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
      )}
      onClick={isDisabled ? undefined : onClick}
      aria-disabled={isDisabled}
    >
      <div className="flex-1 flex flex-col justify-start items-start lg:items-start gap-2">
        <div className="flex flex-col justify-end items-start gap-2">
          <div className="text-black font-medium text-center lg:text-left w-full text-[32px] transition-all duration-300">
            Create a pool
          </div>
        </div>
        <div className="w-full flex flex-col justify-end items-start gap-2">
          <div className="text-black font-medium text-center lg:text-left text-sm transition-all duration-300">
            Start a new funding request backed by your property.
            <br />
            Define your pool amount and terms — we&apos;ll guide you from there.
          </div>
        </div>
      </div>
      <div
        className={clsx(
          'overflow-hidden flex justify-center items-center flex-shrink-0 w-10 h-10 bg-white rounded-[20px] transition-all duration-300',
          !isDisabled && 'group-hover:rounded-full'
        )}
      >
        <img src="/add_pool.svg" alt="Add Pool" className="w-[26px] h-[26px]" />
      </div>
    </div>
  );
};
